import PredictionMinutesAway from 'components/Card/PredictionMinutesAway.js';
import PredictionFrequency from 'components/Card/PredictionFrequency.js';
import PredictionString from 'components/Card/PredictionString.js';

function MassTransitPredictions(props) {
	const {
		rowData,
		vehicleGroup,
	} = props;

	const {
		predictionMinutesAway,
		predictionFrequency,
		predictionString
	} = rowData;

	const { predictionsFormat } = props.card;

	let timeDisplay = props.timeDisplay;

	if (predictionsFormat === 'time' && timeDisplay !== 'actual' && timeDisplay !== 'actual24' && timeDisplay !== 'remaining') {
		timeDisplay = 'actualAMPM';
	}

	let component = '--';

	if (predictionMinutesAway !== null) {
		component = <PredictionMinutesAway vehicleGroup={vehicleGroup} predictionMinutesAway={predictionMinutesAway} timeDisplay={timeDisplay}/>;
	} else if (predictionFrequency !== null) {
		component = <PredictionFrequency predictionFrequency={predictionFrequency} />;
	} else if (predictionString !== null) {
		component = <PredictionString predictionString={predictionString} />;
	}

	return <div className={`MassTransitPredictions`}>{component}</div>;
}

export default MassTransitPredictions;
